// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { postWrapper } from 'helpers/api'
import { change } from 'redux-form'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { PRICING_MANAGEMENT_SEARCH_FORM } from 'components/PricingManagement/constants'
import { handlePricingManagementSearch } from 'redux/modules/pricingManagement'

import {
  submit,
  SubmissionError,
} from 'redux-form'

const updatePricingManagementDetails = formValues => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        pricingGroupType: pricing_group_type,
      } = getState().form[PRICING_MANAGEMENT_SEARCH_FORM].values

      const pricing_group_def = formValues[pricing_group_type]

      const price_initial = castToFloat(formValues.initial)
      const price_subsequent = castToFloat(formValues.subsequent)

      const body = {
        price_initial,
        price_subsequent,
        pricing_group_def,
        pricing_group_type,
      }

      try {
        //setting initial values to be passed when the page refreshes after submit
        const pricingGroupType = (
        pricing_group_type == 'domain' 
        ? 'domain'
        : 'email')
        const pricingGroupDefSearch = '%%'
        await postWrapper('/priceManagement', body)

        //dehighlight selected paths after submit
        change(PRICING_MANAGEMENT_SEARCH_FORM, 'pricingGroupDefSearch', '')
        //refresh page with initial values
        dispatch(handlePricingManagementSearch({ pricingGroupType, pricingGroupDefSearch }))
      } catch (err) {
        throw new SubmissionError({
          _error: err.message || 'Uncaught Error!',
        })
      }
    })
  )
)

export default updatePricingManagementDetails
